import { ref } from '@vue/composition-api'

export default function useAppLayout(props={}) {

  const isVerticalMenuActive = ref(props.isVerticalMenuActive ? props.isVerticalMenuActive : false)
  const isVerticalMenuCollapsed = ref(props.isVerticalMenuCollapsed ? props.isVerticalMenuCollapsed : false)
  const toggleVerticalMenu = () => {
    isVerticalMenuCollapsed.value = !isVerticalMenuCollapsed.value
  }



  return {
    isVerticalMenuActive,
    isVerticalMenuCollapsed,
    toggleVerticalMenu,
  }
}
